export const messages = {
  fr: {
    pageName: 'Plan'
  },
  en: {
    pageName: 'Map'
  },
  us: {
    pageName: 'Map'
  },
  da: {
    pageName: 'Map'
  },
  es: {
    pageName: 'Map'
  },
  nl: {
    pageName: 'Map'
  },
  de: {
    pageName: 'Map'
  },
  it: {
    pageName: 'Map'
  },
  pt: {
    pageName: 'Map'
  },
  zh: {
    pageName: 'Map'
  }
}
